import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import Spinner from 'static/script/libs/spin';
import ItemsInViewportService from 'static/script/app/data/items-in-viewport-service';
import ItemsInViewportUI from 'static/script/app/ui/items-in-viewport-ui';
import ItemCardsUI from 'static/script/app/ui/item-cards-ui';
import 'jquery-lazyload/jquery.lazyload';
import LazyLoad from '../boot/lazy-load';

function LastChanceUI() {
    this.defaultAttrs({
        itemLink: '.item-card a',
        lazyLoadEnabledDataAttribute: 'startpage-lazy-load-enabled',
        lazyLoadSpinnerSelector: '[data-lazy-load-spinner]',
        initData: null
    });

    this._trackClick = function() {
        // TODO: Check if events work after ajax result rendered
        this.trigger(document, 'analytics:track-event', {
            category: 'StartPage',
            action: 'Navigation',
            label: 'Last chance item'
        });
    };

    this._lastChanceVisible = function() {
        this.trigger(document, 'ui:startpage:on-last-chance-visible');
    };

    this._renderLastChanceItems = function(evt, data) {
        $(this.$node).html(data.html);
        ItemCardsUI.attachTo(
            '[data-startpage-lazy-load-last-chance] [data-card-list-container]'
        );

        LazyLoad();
        if (
            this.attr.initData &&
            this.attr.initData.featureSwitches &&
            this.attr.initData.featureSwitches[
                'search-metadata-collection-searchimpression'
            ]
        ) {
            ItemsInViewportService.attachTo(document);
            ItemsInViewportUI.attachTo(
                '[data-startpage-lazy-load-last-chance] [data-card-list-container]'
            );
        }
    };

    this._initSpinner = function() {
        let opts = {
            width: 2,
            length: 4,
            radius: 5,
            lines: 11,
            color: '#404a54'
        };

        let target = this.select('lazyLoadSpinnerSelector')[0];
        let spinner = new Spinner(opts);
        spinner.spin(target);
    };

    this.after('initialize', function() {
        this._initSpinner();

        let container = $(this.$node);

        if (container.data(this.attr.lazyLoadEnabledDataAttribute) === 1) {
            this.on('uiLazyLoaded', this._lastChanceVisible);
            this.$node.lazyload({
                threshold: 300, // Start preloading 300px before the element is on screen
                event: 'scroll.lazyload'
            });
            this.on(
                document,
                'data:startpage:on-last-chance-loaded',
                this._renderLastChanceItems
            );
        }

        this.on('click', {
            itemLink: this._trackClick
        });
    });
}

export default defineComponent.component(LastChanceUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/last-chance-ui.js